import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/logos/footer/Logo-CG-46-Vert-Moyen.png")